import React, { Children, useState} from "react";
import TreeView, {flattenTree} from "react-accessible-treeview";
import {GiHearts, GiSpades, GiClubs, GiDiamonds, GiSpade, GiDimetrodon} from "react-icons/gi";
import { IoMdArrowDropright } from "react-icons/io";
import cx from "classnames"
import styled from "styled-components";




const theme = {
    blue: {
      default: "#3f51b5",
      hover: "#283593",
    },
    pink: {
      default: "#e91e63",
      hover: "#ad1457",
    },
  };

const Button = styled.button`
  background-color: ${(props) => theme[props.theme].default};
  color: white;
  padding: 5px 15px;
  border-radius: 5px;
  outline: 0;
  border: 0; 
  text-transform: uppercase;
  margin: 10px 0px;
  cursor: pointer;
  box-shadow: 0px 2px 2px lightgray;
  transition: ease background-color 250ms;
  &:hover {
    background-color: ${(props) => theme[props.theme].hover};
  }
  &:disabled {
    cursor: default;
    opacity: 0.7;
  }
`;

Button.defaultProps = {
    theme: "blue",
  };



const systemDwustronnaKuba ={
    name: "System",
    children: 
    [
        {id: 1, name: ["kontry otwierającego"],
            children: [
                {id: "1.1", name: ["wywoławcza - zawsze, chyba że wskazany wyjątek poniżej, bądź konwencyjna"]},    
                {id: "1.2", name: ["nadwyżkowa - Co do zasady gdy nie mamy jeszcze znalezionego fitu kontra - nadwyżki siłowe, licytacja koloru - nadwyżki układowe"], children:
                    [
                        {id: '1.2.1', name: ["Gdy partner spasował - ręka około wywoławcza; przyklady"], children:
                            [
                                {id: "1.2.1.1", name: ['1',<GiHearts className="icon-with-space"/>, "- ", '(1',<GiSpades />, ") - pas - (2", <GiSpades />, ") - x" ]},
                                {id: "1.2.1.2", name: ['1',<GiHearts className="icon-with-space"/>, " - ", '(2',<GiClubs />, ") - pas - (pas) - x; - na wznówce może być dwukolorowa, jeżeli z dużą siłą honorową" ]},
                                {id: "1.2.1.3", name: ['1',<GiClubs className="icon-with-space"/>, " - ", '(1',<GiSpades />, ") - pas - (2", <GiSpades />, ") - x; może być 15+ na treflach" ]},
                            ]
                        },
                        {id: '1.2.2', name: ["Gdy partner licytował - jeżeli to nie jest pozycja na kontrę fit"], children:
                            [
                                {id: "1.2.2.1", name: ['1',<GiDiamonds className="icon-with-space"/>, " - (pas) - 1",<GiHearts />," - (2", <GiSpades/>, ") - x" ]}, 
                                {id: "1.2.2.2", name: ['1',<GiHearts className="icon-with-space"/>, " - (1", <GiSpades />, ") - 2",<GiHearts />," - (2", <GiSpades/>, ") - x; inwit, skład zrównoważony" ]},
                                {id: "1.2.2.3", name: ['1',<GiHearts className="icon-with-space"/>, " - (2", <GiDiamonds />, ") - 2",<GiHearts />," - (3", <GiDiamonds/>, ") - x; każdy inwit" ]},
                                {id: "1.2.2.4", name: ['1',<GiClubs className="icon-with-space"/>, " - (pas)",  "1",<GiHearts />," - (2", <GiSpades/>, ") - x; GF na równym, albo 15+ na treflach w składzie wywoławczym" ]},
                                {id: "1.2.2.5", name: ['1',<GiDiamonds className="icon-with-space"/>, " - (1", <GiHearts/>, ") - ",  "1",<GiSpades />," - (2", <GiHearts/>, ") - x; nadwyzka - to nie jest kontra fit!" ]},
                            ]
                        },
                    ]
                },  
                {id: "1.3", name: ["fit - po pasie LHO i nieskaczącej licytacji RHO. Nie jest obligatoryjna - możemy nie dać, z ręką wyraźnie defensywną lub bardzo cienkim otwarciem"], children:
                    [
                        {id: '1.3.1', name: ['1',<GiDiamonds />, " - (pas) - 1",<GiHearts />," - (2", <GiClubs/>, ") - x" ]}
                    ]
                },    
                {id: "1.4", name: ['karniawe/karne'], children:
                    [
                        {id: "1.4.1", name: ['Na bloki od 4',<GiSpades />," w górę"]},
                        {id: "1.4.2", name: ["Po otwarciu 1NT, pasie LHO i dowolnej licytacji partnera"], children:
                            [
                                {id: "1.4.2.1", name:["1NT - (pas) - 2",<GiSpades />," - ","(3",<GiHearts />,") - x; karna"]},
                            ]
                         },
                        {id: "1.4.3", name: ["Gdy można było dać kontrę o charakterze wywoławczym bądź nadwyżkowym wcześniej"] },
                        {id: "1.4.4", name: ["Po wcześniejszej rekontrze partnera"]},                       
                    ]
                 },
                {id: "1.5", name: ["propozycyjne"], children:
                    [
                        {id: "1.5.1", name:['Gdy nie wiemy czy trzeba bronić, czy obkładać'], children:
                            [
                                {id: "1.5.1.1", name:['1',<GiHearts />, " - (1",<GiSpades />,") - 2",<GiHearts />," - (4",<GiSpades />,') -x ' ]},
                                {id: "1.5.1.2", name:['1',<GiDiamonds />, " - (1",<GiSpades />,") - 3",<GiDiamonds />," - (4",<GiSpades />,') -x ' ]},
                            ]
                        },
                        {id: "1.5.2", name:['Gdy już zrobiliśmy bilans, a przeciwnik dalej licytuje. Stopień karności zależy od poziomu licytacji i czy kontra jest pod czy za ręczna'], children:
                            [
                                {id: "1.5.2.1", name:['1',<GiDiamonds />," - (1",<GiSpades />,") - 2",<GiClubs />," - (pas) - 3",<GiClubs />," - (3",<GiSpades />,") - pas - (pas)-x"], children:
                                    [
                                        {id: "1.5.2.1.1", name:['kontra jest propozycyjna (karna na ~50%) - wysoki poziom licytacji, ale pod ręką']},
                                        {id: "1.5.2.1.2", name:['gdyby to odpowiadający dał kontrę, to byłaby kontra w zasadzie karna']},
                                    ]
                                },
                                {id: "1.5.2.2", name:['1',<GiHearts />," - (pas) - 2",<GiHearts />," - (pas) - pas - 3",<GiClubs />," - pas - (pas) -x"], children:
                                    [
                                        {id: "1.5.2.2.1", name:['kontra wywoławcza (pod ręką, niski poziom licytacji), ale z walorami defensywnymi do ewentualnej obrony']},
                                        {id: "1.5.2.2.2", name:['ponownie, gdyby odpowiadający dał kontrę, to byłaby kontra karniawa']},
                                    ]
                                },
                            ]
                        },
                    ],
                },
                {id: "1.6", name: ['kontry wistowe'], children:
                    [
                        {id: "1.6.1", name: ['Na kolor który licytowaliśmy - mocno sugeruje inny wist']},
                        {id: "1.6.2", name: ['Na kolor który licytował partner - obiecuje figurę']},
                        {id: "1.6.3", name: ['Na splintera'], children:
                            [
                                {id: "1.6.3.1", name: ['Jeżeli dwa kolory mają sens (poza atutowym i kolorem krótkości) - wistuj w starszy']},
                                {id: "1.6.3.2", name: ['Jeżeli tylko jeden - wistuj w niego']} 
                            ]
                        },
                        {id: "1.6.4", name: ['Na szlemika - zasadniczo wistuj w pierwszy kolor dziadka, lub w swój najdłuższy kolor do przebitki']},
                        {id: "1.6.5", name: ['Po nieprzymuszonym zalicytowaniu 3NT przez przeciwnika'], children:
                            [
                                {id: "1.6.5.1", name: ['Jeżeli dziadek licytował kolor - wistuj w kolor dziadka']},
                                {id: "1.6.5.2", name: ['Jeżeli dziadek nie licytował koloru (np. 1BA-3BA) - mam dobry kolor, trafiaj']},
                            ]
                        },
                    ]
                }
            ]
        },
        {id: 2, name: ["kontry odpowiadającego"], children:
            [
                {id: "2.1", name: ['wywoławcze - chyba, że jest wskazane inaczej poniżej'], children:
                    [
                        {id: "2.1.1", name: ['Poniżej koloru otwarcia na poziomie dwóch - od 7(6) punktów, szczególnie przed partią']},
                        {id: "2.1.2", name: ['Po blokach na poziomie dwóch - od 10(9) punktów']},
                        {id: "2.1.3", name: ['Po blokach na poziomie trzech - GF, po pasie - ładna karta i góra']},
                    ]
                }, 
                {id: "2.2", name: ["kontry konwencyjne"], children: 
                    [
                        {id: "2.2.1", name: ['kontra jako transfer, różne sekwencje opisane']},
                        {id: "2.2.3", name: ['1NT - (2',<GiClubs />,") *(monokolor lub jakaś forma naturalnego) - x: stayman"]},
                        {id: "2.2.4", name: ['1NT - (2',<GiDiamonds />,") *(multi) - x: wywoławcza do pików, (4)5 HCP"]},
                        {id: "2.2.5", name: ['1x - (2NT) - x',"kontruję jeden młody, GF"]},
                    ]
                },
                {id: "2.3", name: ['kontry propozycyjne'], children: 
                    [
                        {id: "2.3.1", name: ['Po blokach od 4',<GiSpades />," w górę - w zasadzie karne, ale do wyniesienia z ekstremalnie układową kartą"]},
                        {id: "2.3.2", name: ['Po otwarciu na trzecim ręku i wejściu 1NT naturalne']},
                    ]
                },
                {id: "2.4", name: ['kontry karne'], children: 
                    [
                        {id: "2.4.1", name: ['Po bloku partnera i wejściu przeciwnika na poziomie trzech']},
                        {id: "2.4.2", name: ['2',<GiHearts />," - (2",<GiSpades />,") - x: karna"]},
                        {id: "2.4.3", name: ['Po owarciu partnera i wejściu BA naturalne']},
                        {id: "2.4.4", name: ['Jeżeli mogliśmy dać kontrę wywoławczą wcześniej'], children:
                            [
                                {id: "2.4.4.1", name: ['1',<GiDiamonds />," - (1",<GiHearts />,") - pas - (2", <GiHearts />,") - pas - (pas) - x; - kontra karna " ]},
                                {id: "2.4.4.2", name: ['1',<GiDiamonds />," - (1",<GiSpades />,") - pas - (2", <GiHearts />,") - pas - (pas) - x; - miałem trapa na pikach, zrób z tym coś mądrego " ]},
                            ]
                        },

                    ]
                },
                {id: "2.5", name: ['kontry wistowe'], children:
                    [
                        {id: "2.5.1", name: ['Na pytanie o trzymanie/inną licytacje w nasz kolor - wskazuje figurę w kolorze partnera']},
                        {id: "2.5.2", name: ['Na inne sztuczne odzywki - zgrupowanie w tym kolorze']},
                    ]
                },
                {id: "2.6", name: ['kontra BI'], children:
                    [
                        {id: "2.6.1", name: ['Po naszym pasie, gdy jesteśmy na wznówce']},
                    ]
                }
            ]
        },
        {id: 3, name: ["licytacja po niskich, naturalnych wejściach"], children:
            [
                {id: "3.0", name: ["Przeważnie stosujemy transfery, patrz sekwencje poniżej"], children:
                    [
                        {id: "3.0.1", name: ["1",<GiClubs />," - (1",<GiDiamonds />,")"], children:
                            [
                                {id: "3.0.1.1", name: ["x - 4+ ",<GiHearts />]},
                                {id: "3.0.1.2", name: ["1",<GiHearts />," - 4+ ",<GiSpades />]},
                                {id: "3.0.1.3", name: ["1",<GiSpades />," - transfer na BA, wyklucza 4M"]},
                                {id: "3.0.1.4", name: ["1NT - 7-10 bal, trzymanie karo"]},
                                {id: "3.0.1.5", name: ["2",<GiClubs />, " - 5+",<GiSpades />, "4",<GiHearts />," poniżej inwitu"]},
                                {id: "3.0.1.6", name: ["2",<GiDiamonds />, " - 6+ ",<GiHearts />," słabe lub GF"]},
                                {id: "3.0.1.7", name: ["2",<GiHearts />, " - 6+ ",<GiSpades />," słabe lub GF"]},
                                {id: "3.0.1.8", name: ["2",<GiSpades />, " - 6+ ",<GiClubs />," słabe lub GF"]},
                                {id: "3.0.1.9", name: ["2NT - naturalny inwit"]},
                                {id: "3.0.1.10", name: ["3", <GiClubs />, " - 6+ ",<GiClubs />, " - naturalny inwit"]},
                                {id: "3.0.1.11", name: ["3", <GiDiamonds />, " - powiedz 3nt"]}
                            ]
                        },
                        {id: "3.0.2", name: ["1",<GiClubs />," - (1",<GiHearts />,")"], children:
                            [
                                {id: "3.0.2.1", name: ["x - 4+ ",<GiSpades />]},
                                {id: "3.0.2.3", name: ["1",<GiSpades />," - transfer na BA, wyklucza 4M"]},
                                {id: "3.0.2.4", name: ["1NT - 7-10 bal, trzymanie kier"]},
                                {id: "3.0.2.5", name: ["2",<GiClubs />, " - 5(6)+ ",<GiDiamonds />]},
                                {id: "3.0.2.6", name: ["2",<GiDiamonds />, " - oba młode"]},
                                {id: "3.0.2.7", name: ["2",<GiHearts />, " - 6+ ",<GiSpades />," słabe lub GF"]},
                                {id: "3.0.2.8", name: ["2",<GiSpades />, " - 6+ ",<GiClubs />," słabe lub GF"]},
                                {id: "3.0.2.9", name: ["2NT - naturalny inwit"]},
                                {id: "3.0.2.10", name: ["3", <GiClubs />, " - 6+ ",<GiClubs />, " - naturalny inwit"]},
                                {id: "3.0.2.11", name: ["3", <GiDiamonds />, " - 6+ ",<GiDiamonds />, " - naturalny inwit"]}
                            ]
                        },
                        {id: "3.0.3", name: ["1",<GiClubs />," - (1",<GiSpades />,")"], children:
                            [
                                {id: "3.0.3.1", name: ["x - 4 ",<GiHearts/>]},
                                {id: "3.0.3.2", name: ["1NT - 7-10 bal, trzymanie kier"]},
                                {id: "3.0.3.3", name: ["2",<GiClubs />, " - 5+ ",<GiDiamonds />]},
                                {id: "3.0.3.4", name: ["2",<GiDiamonds />, " - 5+ ",<GiHearts />]},
                                {id: "3.0.3.5", name: ["2",<GiHearts />, " - GF, pytanie o trzymanie"]},
                                {id: "3.0.3.6", name: ["2",<GiSpades />, " - 5+ ",<GiClubs />," słabe lub GF"]},
                                {id: "3.0.3.7", name: ["2NT - naturalny inwit"]},
                                {id: "3.0.3.8", name: ["3", <GiClubs />, " - 6+ ",<GiClubs />, " - naturalny inwit"]},
                                {id: "3.0.3.9", name: ["3", <GiDiamonds />, " - 6+ ",<GiDiamonds />, " - naturalny inwit"]},
                                {id: "3.0.3.10", name: ["3", <GiHearts />, " - 6+ ",<GiHearts />, " - naturalny inwit"]}
                            ]
                        },
                        {id: "3.0.4", name: ["1",<GiClubs />," - (1NT)"], children:
                            [
                                {id: "3.0.4.1", name: ["x - karna,10+ PC"]},
                                {id: "3.0.4.3", name: ["2",<GiClubs />, " - stare "]},
                                {id: "3.0.4.4", name: ["2",<GiDiamonds />, " - 5+ ",<GiHearts />]},
                                {id: "3.0.4.5", name: ["2",<GiHearts />, " - 5+ ", <GiSpades />]},
                                {id: "3.0.4.6", name: ["2",<GiSpades />, " - 5+ ",<GiClubs />," - słabe lub GF"]},
                                {id: "3.0.4.7", name: ["2NT - oba młode"]},
                                {id: "3.0.4.8", name: ["3", <GiClubs />, " - 6+ ",<GiDiamonds />]}
                            ]
                        },
                        {id: "3.0.5", name: ["1",<GiClubs />," - (2",<GiClubs />,")"], children:
                            [
                                {id: "3.0.5.1", name: ["x - negatywna, co najmniej 44 w pozostałych"]},
                                {id: "3.0.5.2", name: ["2",<GiDiamonds />, " - 5+ ",<GiHearts />]},
                                {id: "3.0.5.3", name: ["2",<GiHearts />, " - 5+ ", <GiSpades />]},
                                {id: "3.0.5.4", name: ["2",<GiSpades />, " - GF, pytanie o trzymanie"]},
                                {id: "3.0.5.5", name: ["2NT - nat"]},
                                {id: "3.0.5.6", name: ["3", <GiClubs />, " - 6+ ",<GiDiamonds />," słabe lub GF"]},
                                {id: "3.0.5.7", name: ["3", <GiDiamonds />, " - 6+ ",<GiDiamonds />, " - naturalny inwit"]},
                                {id: "3.0.5.8", name: ["3", <GiHearts />, " - 6+ ",<GiHearts />, " - naturalny inwit"]},
                                {id: "3.0.5.9", name: ["3", <GiSpades />, " - 6+ ",<GiSpades />, " - naturalny inwit"]}
                            ]
                        },
                        {id: "3.0.6", name: ["1",<GiDiamonds />," - (1",<GiHearts />,")"], children:
                            [
                                {id: "3.0.6.1", name: ["x - 4+ ",<GiSpades />]},
                                {id: "3.0.6.3", name: ["1",<GiSpades />," - transfer na BA, wyklucza 4S"]},
                                {id: "3.0.6.4", name: ["1NT - 7-10 bal, trzymanie kier"]},
                                {id: "3.0.6.5", name: ["2",<GiClubs />, " - fit poniżej inwitu/GF z fitem "]},
                                {id: "3.0.6.6", name: ["2",<GiDiamonds />, " - inwit z fitem"]},
                                {id: "3.0.6.7", name: ["2",<GiHearts />, " - 6+ ",<GiSpades />," - słabe lub GF"]},
                                {id: "3.0.6.8", name: ["2",<GiSpades />, " - 5+ ",<GiClubs />," - słabe lub GF"]},
                                {id: "3.0.6.9", name: ["2NT - naturalny inwit"]},
                                {id: "3.0.6.10", name: ["3", <GiClubs />, " - 6+ ",<GiClubs />, " - naturalny inwit"]},
                                {id: "3.0.6.11", name: ["3", <GiDiamonds />, " - 6+ ",<GiDiamonds />, " - blok"]},
                                {id: "3.0.6.12", name: ["3", <GiHearts />, " - 6+ ",<GiHearts />, " - krótkość"]},
                                {id: "3.0.6.13", name: ["3", <GiSpades />, " - 6+ ",<GiSpades />, " - naturalny inwit"]}
                            ]
                        },
                        {id: "3.0.7", name: ["1",<GiDiamonds />," - (1",<GiSpades />,")"], children:
                            [
                                {id: "3.0.7.1", name: ["x - 4 ",<GiHearts/>]},
                                {id: "3.0.7.2", name: ["1NT - 7-10 bal, trzymanie kier"]},
                                {id: "3.0.7.3", name: ["2",<GiClubs />, " - fit poniżej inwitu/GF z fitem "]},
                                {id: "3.0.7.4", name: ["2",<GiDiamonds />, " - 5+ ",<GiHearts />]},
                                {id: "3.0.7.5", name: ["2",<GiHearts />, " - inwit z fitem"]},
                                {id: "3.0.7.6", name: ["2",<GiSpades />, " - 5+ ",<GiClubs />," słabe lub GF"]},
                                {id: "3.0.7.7", name: ["2NT - naturalny inwit"]},
                                {id: "3.0.7.8", name: ["3", <GiClubs />, " - 6+ ",<GiClubs />, " - naturalny inwit"]},
                                {id: "3.0.7.9", name: ["3", <GiDiamonds />, " - 6+ ",<GiDiamonds />, " - blok"]},
                                {id: "3.0.7.10", name: ["3", <GiHearts />, " - 6+ ",<GiHearts />, " - naturalny inwit"]}
                            ]
                        },
                        {id: "3.0.8", name: ["1",<GiDiamonds />," - (1NT)"], children:
                            [
                                {id: "3.0.8.1", name: ["x - karna,10+ PC"]},
                                {id: "3.0.8.3", name: ["2",<GiClubs />, " - stare "]},
                                {id: "3.0.8.4", name: ["2",<GiDiamonds />, " - 5+ ",<GiHearts />]},
                                {id: "3.0.8.5", name: ["2",<GiHearts />, " - 5+ ", <GiSpades />]},
                                {id: "3.0.8.6", name: ["2",<GiSpades />, " - 6+ ",<GiClubs />," słabe lub GF"]},
                                {id: "3.0.8.7", name: ["2NT - z fitem karo"]},
                                {id: "3.0.8.8", name: ["3", <GiClubs />, " - 6+",<GiClubs />," inwit układowy"]},
                                {id: "3.0.8.9", name: ["3", <GiDiamonds />, " - 6+ ",<GiDiamonds />, " - blok"]},
                                {id: "3.0.8.10", name: ["3", <GiHearts />, " - 6+ ",<GiHearts />, " - naturalny inwit układowy"]},
                                {id: "3.0.8.11", name: ["3", <GiSpades />, " - 6+ ",<GiSpades />, " - naturalny inwit układowy"]}
                            ]
                        },
                        {id: "3.0.9", name: ["1",<GiDiamonds />," - (2",<GiClubs />,")"], children:
                            [
                                {id: "3.0.9.1", name: ["x - negatywna, co najmniej 44 w pozostałych"]},
                                {id: "3.0.9.2", name: ["2",<GiDiamonds />, " - 5+ ",<GiHearts />]},
                                {id: "3.0.9.3", name: ["2",<GiHearts />, " - 5+ ", <GiSpades />]},
                                {id: "3.0.9.4", name: ["2",<GiSpades />, " - GF z fitem"]},
                                {id: "3.0.9.5", name: ["2NT - naturalny inwit z fitem "]},
                                {id: "3.0.9.6", name: ["3", <GiClubs />, " - mixed raise"]},
                                {id: "3.0.9.7", name: ["3", <GiDiamonds />, " - blok"]},
                                {id: "3.0.9.8", name: ["3", <GiHearts />, " - 6+ ",<GiHearts />, " - naturalny inwit"]},
                                {id: "3.0.9.9", name: ["3", <GiSpades />, " - 6+ ",<GiSpades />, " - naturalny inwit"]}
                            ]
                        },
                        {id: "3.0.10", name: ["1",<GiHearts />," - (1",<GiSpades />,")"], children:
                            [
                                {id: "3.0.10.1", name: ["x - 4 negatywna"]},
                                {id: "3.0.10.2", name: ["1NT - 7-10 bal, trzymanie pik"]},
                                {id: "3.0.10.3", name: ["2",<GiClubs />, " - 5+ ",<GiDiamonds />]},
                                {id: "3.0.10.4", name: ["2",<GiDiamonds />, " - słaby z fitem lub GF fitem"]},
                                {id: "3.0.10.5", name: ["2",<GiHearts />, " - konstruktywne z fitem"]},
                                {id: "3.0.10.6", name: ["2",<GiSpades />, " - 5+ ",<GiClubs />," - słabe lub GF"]},
                                {id: "3.0.10.7", name: ["2NT - inwit z fitem"]},
                                {id: "3.0.10.8", name: ["3", <GiClubs />, " - 6+ ",<GiClubs />, " - naturalny inwit"]},
                                {id: "3.0.10.9", name: ["3", <GiDiamonds />, " - mixed raise"]},
                                {id: "3.0.10.10", name: ["3", <GiHearts />, " - blok"]},
                                {id: "3.0.10.11", name: ["3", <GiSpades />, " - splinter"]}
                            ]
                        },
                        {id: "3.0.11", name: ["1",<GiHearts />," - (1NT)"], children:
                            [
                                {id: "3.0.11.1", name: ["x - karna,10+ PC"]},
                                {id: "3.0.11.3", name: ["2",<GiClubs />, " - 5+ ",<GiDiamonds />]},
                                {id: "3.0.11.4", name: ["2",<GiDiamonds />, " - konstrutywne z fitem"]},
                                {id: "3.0.11.5", name: ["2",<GiHearts />, " - 5+ ", <GiSpades />]},
                                {id: "3.0.11.6", name: ["2",<GiSpades />, " - mixed raise"]},
                                {id: "3.0.11.7", name: ["2NT -  6+",<GiClubs />,]},
                                {id: "3.0.11.8", name: ["3", <GiClubs />, " - 6+",<GiClubs />,"naturalny inwit układowy"]},
                                {id: "3.0.11.9", name: ["3", <GiDiamonds />, " - 6+ ",<GiDiamonds />," - naturalny inwit układowy"]},
                                {id: "3.0.11.10", name: ["3", <GiHearts />, " -  blok "]},
                                {id: "3.0.11.11", name: ["3", <GiSpades />, " - 6+ ",<GiSpades />, " - naturalny inwit układowy"]}
                            ]
                        },
                        {id: "3.0.13", name: ["1",<GiHearts />," - (2",<GiClubs />,")"], children:
                            [
                                {id: "3.0.13.1", name: ["x - negatywna "]},
                                {id: "3.0.13.4", name: ["2",<GiDiamonds />, " - słaby z fitem lub GF fitem"]},
                                {id: "3.0.13.5", name: ["2",<GiHearts />, " - 5+",<GiSpades />]},
                                {id: "3.0.13.6", name: ["2",<GiSpades />, " - mixed raise"]},
                                {id: "3.0.13.7", name: ["2NT - inwit z fitem"]},
                                {id: "3.0.13.8", name: ["3", <GiClubs />, " - 6+ ",<GiDiamonds />, " - słabe/ GF"]},
                                {id: "3.0.13.9", name: ["3", <GiDiamonds />, " - naturalny inwit"]},
                                {id: "3.0.13.10", name: ["3", <GiHearts />, " - blok"]},
                                {id: "3.0.13.11", name: ["3", <GiSpades />, " - 6+ ",<GiSpades />, " - naturalny inwit"]}
                            ]
                        },
                        {id: "3.0.12", name: ["1",<GiSpades />," - (1NT)"], children:
                            [
                                {id: "3.0.12.1", name: ["x - karna,10+ PC"]},
                                {id: "3.0.12.3", name: ["2",<GiClubs />, " - 5+ ",<GiDiamonds />]},
                                {id: "3.0.12.4", name: ["2",<GiDiamonds />, " - 5+ ",<GiHearts />]},
                                {id: "3.0.12.5", name: ["2",<GiHearts />, " -  konstruktywne z fitem"]},
                                {id: "3.0.12.6", name: ["2",<GiSpades />, " - 6+",<GiClubs />,]},
                                {id: "3.0.12.7", name: ["2NT - od mixed raise do GF włącznie"]},
                                {id: "3.0.12.8", name: ["3", <GiClubs />, " - 6+",<GiClubs />,"naturalny inwit układowy"]},
                                {id: "3.0.12.9", name: ["3", <GiDiamonds />, " - 6+ ",<GiDiamonds />," - naturalny inwit układowy"]},
                                {id: "3.0.12.10", name: ["3", <GiHearts />, " - 6+ ",<GiHearts />, " - naturalny inwit układowy"]},
                                {id: "3.0.12.11", name: ["3", <GiSpades />, " - blok"]}
                            ]
                        },

                        {id: "3.0.15", name: ["1",<GiSpades />," - (2",<GiClubs />,")"], children:
                            [
                                {id: "3.0.15.1", name: ["x - negatywna"]},
                                {id: "3.0.15.4", name: ["2",<GiDiamonds />, " - 5+ ",<GiHearts />]},
                                {id: "3.0.15.5", name: ["2",<GiHearts />, " - słaby z fitem lub GF fitem"]},
                                {id: "3.0.15.6", name: ["2",<GiSpades />, " - konstruktywne z fitem"]},
                                {id: "3.0.15.7", name: ["2NT - inwit z fitem"]},
                                {id: "3.0.15.8", name: ["3", <GiClubs />, " - 6+ ",<GiDiamonds />, " - słabe/ GF"]},
                                {id: "3.0.15.9", name: ["3", <GiDiamonds />, " - naturalny inwit"]},
                                {id: "3.0.15.10", name: ["3", <GiHearts />, " - 6+ ",<GiHearts />, " - mixed raise"]},
                                {id: "3.0.15.11", name: ["3", <GiSpades />, " - blok"]}
                            ]
                        }
                    ]
                },
                {id: "3.1", name: ["Jeżeli nie dajemy transferu, nowy kolor na poziomie jednego forsuje, na poziomie dwóch NF"]},
                {id: "3.2", name: ["1",<GiHearts />,"/",<GiSpades />," - (2X)"], children:
                    [
                        {id: "3.2.1", name: ["Bliższa z (3X)/2NT - GF z fitem"]},
                        {id: "3.2.2", name: ["Dalsza z (3X)/2NT - inwit z fitem"]},
                        {id: "3.2.3", name: ["Splintery - tylko w kolor przeciwnika"]},
                        {id: "3.2.4", name: ["Inne na wysokim poziomie - kolor + fit, GF"]}
                    ]
                },
                {id: "3.3", name: ["1",<GiClubs />,"/",<GiDiamonds />," - (1NT) - 2",<GiClubs />," - stare"]},
                {id: "3.4", name: ["Po otwarciu na trzecim ręku w stary kolor i interwencji przeciwnika - 2NT - góra pasa z z czterokrotnym fitem"]},
                {id: "3.5", name: ["1NT - (2",<GiDiamonds />,"/",<GiHearts />,"/",<GiSpades />,") - 2NT - Lebensohl"]},
                {id: "3.6", name: ["Po naturalnym wejściu BA"], children:
                    [
                        {id: "3.6.1", name: ["x - karna, z nastawieniem na kontrowanie przeciwników. Dalsze pasy forsujące, ale nie GF"]},
                        {id: "3.6.2", name: ["2",<GiClubs />," - stare, (o ile padło otwarcie w młody)"]},
                        {id: "3.6.3", name: ["2NT - układowy inwit z fitem, (o ile padło otwarcie w stary)"]}
                    ]
                }
            ]    
        },
        {id: 16, name: ["Po kontrze wywoławczej przeciwnika"], children:
            [
                {id: "16.0", name: ["Po kontrze wyw. na otwarcia na poziomie jednego stosujemy transfery, poza otwarciem 1",<GiDiamonds />]},
                {id: "16.1", name: ["Na 1",<GiClubs />,], children:
                    [
                        {id: "16.1.0", name: ["xx - 10+ z chęcia kontrowania, raczej bez starszej piątki w sile GF"]},
                        {id: "16.1.1", name: ["Pas - dowolne 0-6"]},
                        {id: "16.1.2", name: ["1",<GiDiamonds />," - 4+ kiery"]},
                        {id: "16.1.3", name: ["1",<GiHearts />," - 4+ piki"]},
                        {id: "16.1.4", name: ["1",<GiSpades />," - tr. na BA, wyklucza 4M"]},
                        {id: "16.1.5", name: ["1NT"," - 7-10 bal, wyklucza 4M"]},
                        {id: "16.1.6", name: ["2",<GiClubs />," - 5(6) kar, słabe lub GF"]},
                        {id: "16.1.7", name: ["2",<GiDiamonds />," - 6+ kierów, słabe lub GF"], children:
                            [
                                {id: "16.1.7.1", name: ["2",<GiHearts />," - dokładnie 2 kiery"]},
                                {id: "16.1.7.2", name: ["3",<GiHearts />," - dokładnie 3 kiery"]},
                                {id: "16.1.7.3", name: ["2NT"," - silny relay"]}
                            ]
                        },
                        {id: "16.1.8", name: ["2",<GiSpades />," - 6+ pików, słabe lub GF"], children:
                            [
                                {id: "16.1.8.1", name: ["2",<GiSpades />," - dokładnie 2 piki"]},
                                {id: "16.1.8.2", name: ["3",<GiSpades />," - dokładnie 3 kiery"]},
                                {id: "16.1.8.3", name: ["2NT"," - silny relay"]}
                            ]
                        }
                    ]
                },
                {id: "16.2", name: ["Na 1",<GiDiamonds />," - system on"]},
                {id: "16.3", name: ["Na 1",<GiHearts />,], children:
                    [
                        {id: "16.3.1", name: ["Pas - nic ciekawego"]},
                        {id: "16.3.14", name: ["xx - 10+ z chęcia kontrowania, jeżeli z fitem to zrównoważony"]},
                        {id: "16.3.2", name: ["1",<GiSpades />," - naturalne"]},
                        {id: "16.3.3", name: ["1NT - 5+ trefli, słabe lub GF"]},
                        {id: "16.3.4", name: ["2",<GiClubs /> ,"5+ kar, słabe lub GF"]},
                        {id: "16.3.5", name: ["2",<GiDiamonds /> ,"fit kier, 4-6(7)HCP lub GF"]},
                        {id: "16.3.6", name: ["2",<GiHearts /> ,"fit kier, (7)8-9(10)HCP"]},
                        {id: "16.3.7", name: ["2",<GiSpades /> ,"mixed raise"]},
                        {id: "16.3.8", name: ["2NT - inwit z fitem, raczej 4+, jeżeli 3 kartowy to z krótkością"]},
                        {id: "16.3.10", name: ["3", <GiClubs />, " - 6+ ",<GiClubs />, " naturalny inwit"]},
                        {id: "16.3.11", name: ["3", <GiDiamonds />, " - 6+ ",<GiDiamonds />, " - naturalny inwit"]},
                        {id: "16.3.12", name: ["3", <GiHearts />, " - 6+ ",<GiHearts />, " - blok"]},
                        {id: "16.3.13", name: ["3", <GiSpades />, " - 6+ ",<GiSpades />, " - dowolny renons"]}
                    ]
                },
                {id: "16.4", name: ["Na 1",<GiSpades />,], children:
                    [
                        {id: "16.4.1", name: ["xx - 10+ z chęcia kontrowania, jeżeli z fitem to zrównoważony"]},
                        {id: "16.4.2", name: ["1NT - 5+ trefli, konstruktywne, nielimitowane"]},
                        {id: "16.4.3", name: ["2",<GiClubs /> ," - 5+ kar, konstruktywne, nielimitowane"]},
                        {id: "16.4.4", name: ["2",<GiDiamonds /> ," - 5+ kierów, konstruktywne, nielimitowane"]},
                        {id: "16.4.5", name: ["2",<GiHearts /> ," - fit pik, 4-6(7)HCP lub GF"]},
                        {id: "16.4.6", name: ["2",<GiHearts /> ," - fit pik, (7)8-9(10)HCP"]},
                        {id: "16.4.7", name: ["2NT - inwit z fitem, raczej 4+, jeżeli 3 kartowy to z krótkością"]},
                        {id: "16.4.8", name: ["3", <GiClubs />, " -6+ ",<GiClubs />, " naturalny inwit"]},
                        {id: "16.4.9", name: ["3", <GiDiamonds />, " - 6+ ",<GiDiamonds />, " - naturalny inwit"]},
                        {id: "16.4.10", name: ["3", <GiHearts />, " - mixed raise"]},
                        {id: "16.4.11", name: ["3", <GiSpades />, " - 6+ ",<GiSpades />, " - blok"]}
                    ]
                },   
            ]    
        },
        {id: 4, name: ["Po wejściach sztucznych i dwukolorowych"], children:
            [
                {id: "4.1", name: ["Po 2",<GiDiamonds />,"Multi"], children:
                    [
                        {id: "4.1.1", name: ["x - wywoławcza do pików"]},
                        {id: "4.1.2", name: ["2",<GiHearts />,'/',<GiSpades />, "Nat, NF"]},
                        {id: "4.1.3", name: ["2NT -  nat, inwit"]},
                        {id: "4.1.4", name: ["2NT poprzedzone wcześniejszym pasem - młode"]},
                    ]
                },
                {id: "4.2", name: ["Po 2",<GiDiamonds />," Stare"], children:
                    [
                        {id: "4.2.1", name: ["pas a potem kontra - karna, kontrowałem oba stare"]},
                        {id: "4.2.2", name: ["x - kontruję jeden stary, forsuje do 2NT"]},
                        {id: "4.2.3", name: ["2",<GiHearts />,"/",<GiSpades />," - z wartości, GF"]},
                        {id: "4.2.4", name: ["2NT - naturalny inwit"]},
                    ]
                },
                {id: "4.7", name: ["Po 2",<GiDiamonds />, "Wilkosz"], children:
                    [
                        {id: "4.7.1", name: ["Identycznie jak po multi"]},
                    ]
                },
                {id: "4.3", name: ["1",<GiClubs />, " - (2NT) - młode" ], children:
                    [
                        {id: "4.3.1", name: ["pas a potem kontra - karna, kontrowałem oba stare"]},
                        {id: "4.3.2", name: ["x - kontruję jeden młody, (ewentualnie trzymanie tylko w jednym kolorze)"]},
                        {id: "4.3.3", name: ["3",<GiClubs />," - ","Oba stare kolory, dłuższe kiery GF"]},
                        {id: "4.3.4", name: ["3",<GiDiamonds />," - ","Oba stare kolory, dłuższe piki GF"]},
                    ] 
                },
                {id: "4.4", name: ["1",<GiHearts />,"/",<GiSpades />," - (2NT)  - młode"], children:
                    [
                        {id: "4.4.1", name: ["pas a potem kontra - karna, kontrowałem oba stare"]},
                        {id: "4.4.2", name: ["x - kontruję jeden młody, (ewentualnie trzymanie tylko w jednym kolorze)"]},
                        {id: "4.4.3", name: ["3",<GiClubs />," - ","GF z fitem"]},
                        {id: "4.4.4", name: ["3",<GiDiamonds />," - ","inwit z fitem"]},
                        {id: "4.4.5", name: ["Drugi stary  - Nat, GF"]},
                    ] 
                },
                {id: "4.5", name: ["1",<GiSpades />," - (2",<GiSpades />,") - Micheals"], children:
                    [
                        {id: "4.5.1", name: ["pas - może być trap"]},
                        {id: "4.5.2", name: ["x - punkty, bez fitu"]},
                        {id: "4.5.3", name: ["2NT - GF z fitem"]},
                        {id: "4.5.4", name: ["3",<GiHearts />," - ","inwit z fitem"]}, 
                    ]
                },
                {id: "4.6", name: ["Po wejściu BA 54"], children:
                    [
                        {id: "4.6.1", name: ["pas - może być trap na kolorze starszym"]},
                        {id: "4.6.2", name: ["x - punkty, bez fitu"]},
                        {id: "4.6.3", name: ["2 w stary - GF z fitem"]},
                        {id: "4.6.4", name: ["2NT - inwit z fitem"]},
                    ]
                },
            ]
        },
        {id: 5, name: ["Po wyższych blokach"], children:
            [
                {id: "5.1", name:  "x - GF, bez fitu. Nie obiecuje obu starszych czwórek, po niej z dowolną nadwyżką (w tym silnym treflem) licytujemy powoli"},
                {id: "5.2", name:["Po otwarciu w stary i bloku w młody"], children:
                    [
                        {id: "5.2.1", name:["4 w kolor bloku - GF z fitem i krótkością w licytowanym kolorze"]},
                        {id: "5.2.2", name:["4 w drugi kolor młodszy - GF z fitem, bez krótkości w kolorze bloku"]},
                        {id: "5.2.3", name:["4 w kolor otwarcia - do gry, nie tworzy pozycji pasa forsującego"]},
                        {id: "5.2.4", name:["5 w drugi kolor młodszy - do gry"]},
                        {id: "5.2.5", name:["Powyższe tyczy się też sekwecji",<GiSpades />, " - (3", <GiHearts />, ")"]},
                    ]
                },
                {id: "5.3", name:["Po blokach na poziomie 4"], children:
                    [
                        {id: "5.3.1", name:["4NT - inwit do szlemika z fitem"]}, 
                    ]
                },
            ],
        },
        {id: 6, name: ["Licytacja po multi i interwencji kontrą" ], children:
            [
                {id: "6.1", name: ["xx - zalicytuj 2",<GiHearts />," a potem pasuj"]},
                {id: "6.2", name: ["pas - sugestia gry w kara"]},
                {id: "6.3", name: ["Inne - jak bez interwencji"]}
            ]
        },
        {id: 7, name:["Obrona po 1BA przeciwnika"], children:
            [
                {id: "7.1", name:["Na pozycji bezpośredniej"], children: 
                    [
                        {id: "7.1.1", name:["x - ","5 młodsza, 4 starsza"], children:
                            [
                                {id: "7.1.1.1", name:["2",<GiClubs />," - ","do koloru młodszego"]},
                                {id: "7.1.1.2", name:["2",<GiDiamonds />," - ","nie chcę grać w trefle"]},
                                {id: "7.1.1.3", name:["2",<GiHearts />," - ","fity w starych"]},
                                {id: "7.1.1.4", name:["2",<GiSpades />," - ","z własnego"]},
                            ]
                        },
                        {id: "7.1.2", name:["2",<GiClubs />," - ","stare"], children:
                            [
                                {id: "7.1.2.1", name:["2",<GiDiamonds />," - ","pokaż dłuższy kolor"]},
                                {id: "7.1.2.2", name:["2",<GiHearts />," - ","wybór koloru"]},
                                {id: "7.1.2.3", name:["2",<GiSpades />," - ","wybór koloru"]},
                                {id: "7.1.2.4", name:["2NT"," - ","silny inwit z fitami"]},
                            ]
                        },
                        {id: "7.1.3", name:["2",<GiDiamonds />," - ","starsza szóstka"], children:
                            [
                                {id: "7.1.3.1", name:["jak po multi w jednostronnej"]},
                            ]
                        },
                        {id: "7.1.4", name:["2",<GiHearts />," - ","5 kierów, młodsza czwórka"], children:
                            [
                                {id: "7.1.4.1", name:["2",<GiSpades />," - ","z własnego"]},
                                {id: "7.1.4.2", name:["2NT"," - ","silny inwit"]},
                                {id: "7.1.4.3", name:["3",<GiClubs />," - ","do koloru młodszego"]},
                                {id: "7.1.4.4", name:["3",<GiHearts />," - ","lekki inwit z fitem"]},
                            ]
                        },
                        {id: "7.1.5", name:["2",<GiSpades />," - ","5 kierów, młodsza czwórka"], children:
                            [
                                {id: "7.1.5.1", name:["2NT"," - ","pytanie o skład, silny inwit z fitem lub na młodym"]},
                                {id: "7.1.5.2", name:["3",<GiClubs />," - ","do koloru młodszego"]},
                                {id: "7.1.5.3", name:["3",<GiSpades />," - ","lekki inwit z fitem"]},
                            ]
                        }
                    ]
                },
                {id: "7.2", name:["Na pozycji wygasającej"], children:
                    [
                        {id: "7.2.1", name:["x - ","co najmniej dwa kolory do gry z tolerancją do gry w stary"], children:
                            [
                                {id: "7.2.1.1", name:["2",<GiClubs />," - do koloru"]},
                                {id: "7.2.1.2", name:["2",<GiDiamonds />," - z własnego"]},
                                {id: "7.2.1.3", name:["2",<GiHearts />," - z własnego"]},
                                {id: "7.2.1.4", name:["2",<GiSpades />," - z własnego"]},
                            ]
                        },
                        {id: "7.2.2", name:["2",<GiClubs />," - ","stare"], children:
                            [
                                {id: "7.2.2.1", name:["2",<GiDiamonds />," - ","pokaż dłuższy kolor"]},
                                {id: "7.2.2.2", name:["2",<GiHearts />," - ","wybór koloru"]},
                                {id: "7.2.2.3", name:["2",<GiSpades />," - ","wybór koloru"]},
                                {id: "7.2.2.4", name:["3",<GiDiamonds />," - ","silny inwit z fitami"]},
                            ]
                        },
                        {id: "7.2.3", name:["2",<GiDiamonds />," - ","naturalne"]}, //, children:
                        //     [
                        //         {id: "7.2.3.1", name:["2",<GiHearts />," - ","do koloru"]},
                        //         {id: "7.2.3.2", name:["2",<GiSpades />," - ","lepsza karta do kierów"]},
                        //         {id: "7.2.3.3", name:["3",<GiDiamonds />," - ","inwit z fitami"]},
                        //     ]
                        // },
                        {id: "7.2.4", name:["2",<GiHearts />," - ","5+, naturalne"]},
                        {id: "7.2.5", name:["2",<GiSpades />," - ","5+, naturalne"]},
                    ]
                },
            ]
        },
        {id: 8, name: ["Po naturalnych otwarciach przeciwnika" ], children:
            [
                {id: "8.1", name: ["Jeżeli nie jest wskazane inaczej - wejście naturalne, poniżej kontry objaśniającej, po otwarciach konstruktywnych skoki blokujące " ]},
                {id: "8.2", name: ["1",<GiClubs />], children:
                    [
                        {id: "8.2.1", name: ["2",<GiDiamonds />," - ","obie starsze, raczej 5" ]},
                        {id: "8.2.2", name: ["2NT - 55 młode, blokujące lub silne"]},
                        {id: "8.2.3", name: ["3NT - do gry na własnym kolorze"]},
                    ]
                },
                {id: "8.3", name: ["1",<GiDiamonds />], children:
                    [
                        {id: "8.3.1", name: ["2",<GiDiamonds />," - ","obie starsze, raczej 5" ]},
                        {id: "8.3.2", name: ["2NT - 55 trefle i kiery"]},
                        {id: "8.3.3", name: ["3NT - do gry na własnym kolorze"]},
                    ]
                },
                {id: "8.4", name: ["1",<GiHearts />], children:
                    [
                        {id: "8.4.1", name: ["2",<GiHearts />," - ","dwukolorówka piki z młodszym" ]},
                        {id: "8.4.2", name: ["3",<GiHearts />," - ","(??) pełny młodszy, kontruktywne, pyta o trzymanie" ]},
                        {id: "8.4.3", name: ["4NT - duża dwuoklorówka na młodych, ofensywna karta"]},
                    ]
                },
                {id: "8.5", name: ["1",<GiSpades />], children:
                    [
                        {id: "8.5.1", name: ["2",<GiSpades />," - ","dwukolorówka kiery z młodszym" ]},
                        {id: "8.5.2", name: ["3",<GiSpades />," - ","pełny młodszy, kontruktywne, pyta o trzymanie" ]},
                        {id: "8.5.3", name: ["4NT - duża dwukolorówka na młodych, ofensywna karta"]},       
                    ]
                }, 
                {id: "8.6", name: ["2",<GiClubs />], children:
                    [
                        {id: "8.6.1", name: ["3",<GiClubs />," - ","dwukolorówka na starych" ]},
                        {id: "8.6.2", name: ["Po pytaniu 2", <GiDiamonds />, " - x ","wywoławcza do trefli" ]},
                    ]
                },
                {id: "8.7", name: ["2",<GiHearts />], children:
                    [
                        {id: "8.7.1", name: ["3",<GiHearts />," - ","dwukolorówka z pikami, nie forsuje do końcówki" ]},
                        {id: "8.7.2", name: ["3",<GiSpades />," - ","kostruktywne, 6+ pików, około 15 HCP" ]},
                        {id: "8.7.3", name: ["4",<GiClubs />," - ","dwukolorówka trefle i piki, GF" ]},
                        {id: "8.7.4", name: ["4",<GiDiamonds />," - ","dwukolorówka kara i piki, GF" ]},
                        {id: "8.7.5", name: ["4",<GiHearts />," - ","??" ]},
                        {id: "8.7.6", name: ["4NT - dwukolorówka na młodych" ]},
                    ]
                },
                {id: "8.8", name: ["2",<GiSpades />], children:
                    [
                        {id: "8.8.2", name: ["3",<GiSpades />," - ","??" ]},
                        {id: "8.8.3", name: ["4",<GiClubs />," - ","dwukolorówka trefle i kiery, GF" ]},
                        {id: "8.8.4", name: ["4",<GiDiamonds />," - ","dwukolorówka kara i kiery, GF" ]},
                        {id: "8.8.5", name: ["4",<GiSpades />," - ","??" ]},
                        {id: "8.8.6", name: ["4NT - dwukolorówka na młodych" ]},
                    ]
                },
                {id: "8.11", name: ["3",<GiClubs />], children:
                    [
                        {id: "8.11.1", name: ["4",<GiClubs />," - ","dwukolorówka na starych, GF" ]},
                        {id: "8.11.2", name: ["4",<GiDiamonds />," - ","dwukolorówka kara + stary, GF"], children:
                            [
                                {id: "8.11.2.1", name: ["4",<GiHearts />," - ","Pass or correct"]},
                                {id: "8.11.2.2", name: ["4",<GiSpades />," - ","do pasa z pikami, może być lekki inwit z fitem kierowym lub karowym"]},
                                {id: "8.11.2.3", name: ["4NT - inwitująca karta z nieznamy fitem"]},
                                {id: "8.11.2.4", name: ["5",<GiClubs />, "- ", "cuebid"]},
                            ]
                        },
                    ]
                },
                {id: "8.9", name: ["3",<GiDiamonds />], children:
                    [
                        {id: "8.9.1", name: ["4",<GiClubs />," - ","dwukolorówka trefle + stary, GF" ], children:
                            [
                                {id: "8.9.1.1", name: ["4",<GiHearts />," - ","Pass or correct"]},
                                {id: "8.9.1.2", name: ["4",<GiSpades />," - ","do pasa z pikami, może być lekki inwit z fitem kierowym lub karowym"]},
                                {id: "8.9.1.3", name: ["4NT - inwitująca karta z nieznamy fitem"]},
                            ]
                        },
                        {id: "8.9.2", name: ["4",<GiDiamonds />," - ","dwukolorówka kara + stary, GF"], children:
                            [
                                {id: "8.9.2.1", name: ["4",<GiHearts />," - ","Pass or correct"]},
                                {id: "8.9.2.2", name: ["4",<GiSpades />," - ","do pasa z pikami, może być lekki inwit z fitem kierowym lub karowym"]},
                                {id: "8.9.2.3", name: ["4NT - inwitująca karta z nieznamy fitem"]},
                                {id: "8.9.2.4", name: ["5",<GiClubs />," - ","cuebid"]},
                            ]
                        },
                    ]
                },
                {id: "8.10", name: ["3",<GiHearts />,"/3",<GiSpades />], children:
                    [
                        {id: "8.10.1", name: ["4",<GiClubs />," - ","dwukolorówka trefle + drugi stary, GF" ], children:
                            [
                                {id: "8.10.1.1", name: ["4",<GiHearts />," - ","Pass or correct"]},
                                {id: "8.10.1.2", name: ["4",<GiSpades />," - ","do pasa z pikami, może być lekki inwit z fitem kierowym lub treflowym"]},
                                {id: "8.10.1.3", name: ["4NT - inwitująca karta z nieznamy fitem"]},
                            ]
                        },
                        {id: "8.10.2", name: ["4",<GiDiamonds />," - ","dwukolorówka kara + stary, GF"], children:
                            [
                                {id: "8.10.2.1", name: ["4",<GiHearts />," - ","Pass or correct"]},
                                {id: "8.10.2.2", name: ["4",<GiSpades />," - ","do pasa z pikami, może być lekki inwit z fitem kierowym lub karowym"]},
                                {id: "8.10.2.3", name: ["4NT - inwitująca karta z nieznamy fitem"]},
                                {id: "8.10.2.4", name: ["5",<GiClubs />," - ","cuebid"]},
                            ]
                        },
                    ]
                },
            ]
        },
        {id: 9, name: ["Po 2",<GiClubs />," - ","stare, blokujące"], children:
            [
                {id: "9.1", name: ["x"," - ","punkty, skład około zrównoważony z tolerancją do gry w oba młode"]},
                {id: "9.2", name: ["2",<GiDiamonds />," - ","naturalne, kara"]},
                {id: "9.3", name: ["2",<GiHearts />," - ","naturalne, raczej z 6-ciu kierów"]},
                {id: "9.4", name: ["2",<GiSpades />," - ","naturalne, raczej z 6-ciu pików"]},
                {id: "9.5", name: ["2NT"," - ","(15)16-18"]},
            ]
        },
        {id: 20, name: ["Po 2",<GiDiamonds />," - ","Multi"], children:
            [
                {id: "20.1", name: ["x - ","wywoławcza do pików lub objaśniająca"], children:
                    [
                        {id: "20.1.1", name: ["jeżeli nastąpił pas - sugestia gry w kara"], children:
                            [
                                {id: "20.1.1.1", name: ["pas - mogę grać 2dx"]},
                                {id: "20.1.1.2", name: ["2", <GiHearts />, "- słaba karta z kierami"]},
                                {id: "20.1.1.3", name: ["2", <GiSpades />, "- GF"]},
                                {id: "20.1.1.4", name: ["2NT - Lebensohl"]},
                                {id: "20.1.1.5", name: ["3",<GiClubs /> - "inwitujące na treflach"]},
                                {id: "20.1.1.6", name: ["3",<GiDiamonds /> - "pytanie o trzymanie w karach"]},
                                {id: "20.1.1.7", name: ["3",<GiHearts /> - "bilansowe z kierami"]},
                                {id: "20.1.1.8", name: ["3",<GiSpades /> - "bilansowe z 6+ pikami"]},
                            ]
                        },
                        {id: "20.1.2", name: ["jeżeli nastąpiła xx - pokaż kolor"], children:
                            [
                                {id: "20.1.2.1", name: ["pas - nic ciekawego"]},
                                {id: "20.1.2.2", name: ["2",<GiHearts />," - 4+ kiery, konstruktywne NF"]},
                                {id: "20.1.2.3", name: ["2",<GiSpades />," - ??"]},
                                {id: "20.1.2.4", name: ["2NT - bilansowe, naturalne"]},
                                {id: "20.1.2.5", name: ["3",<GiClubs />," - bilansowe, naturalne"]},
                                {id: "20.1.2.6", name: ["3",<GiDiamonds />," - bilansowe, naturalne"]},
                                {id: "20.1.2.7", name: ["3",<GiHearts />," - bilansowe, naturalne"]},
                                {id: "20.1.2.8", name: ["3",<GiSpades />," - ??"]},
                            ]
                        },
                        {id: "20.1.3", name: ["jeżeli nastąpiło 2 kier - do koloru"], children:
                            [
                                {id: "20.1.3.1", name: ["x - 4kiery, konstruktywe"]},
                                {id: "20.1.3.3", name: ["2",<GiSpades />," - ??"]},
                                {id: "20.1.3.4", name: ["2NT - bilansowe, naturalne"]},
                                {id: "20.1.3.5", name: ["3",<GiClubs />," - bilansowe, naturalne"]},
                                {id: "20.1.3.6", name: ["3",<GiDiamonds />," - bilansowe, naturalne"]},
                                {id: "20.1.3.7", name: ["3",<GiHearts />," - bilansowe, naturalne"]},
                                {id: "20.1.3.8", name: ["3",<GiSpades />," - ??"]},
                            ]
                        },
                        {id: "20.1.4", name: ["jeżeli nastąpiło 2 pik - do koloru"], children:
                            [
                                {id: "20.1.4.1", name: ["x - 4kiery, konstruktywe"]},
                                {id: "20.1.4.4", name: ["2NT - bilansowe, naturalne"]},
                                {id: "20.1.4.5", name: ["3",<GiClubs />," - bilansowe, naturalne"]},
                                {id: "20.1.4.6", name: ["3",<GiDiamonds />," - bilansowe, naturalne"]},
                                {id: "20.1.4.7", name: ["3",<GiHearts />," - bilansowe, naturalne"]},
                                {id: "20.1.4.8", name: ["3",<GiSpades />," - ??"]},
                            ]
                        },
                        {id: "20.1.5", name: ["jeżeli nastąpiło 3 kier - blokujące"], children:
                            [
                                {id: "20.1.5.1", name: ["x - 4kiery, konstruktywe, inwitujące do końcówki"]},
                                {id: "20.1.5.2", name: ["3",<GiSpades />, "silna karta bez trzymania pik"]},
                            ]
                        },
                    ]
                },
                {id: "20.2", name: ["Wejścia w kolor - ","naturalne" ], children:
                    [
                        {id: "20.2.1", name: ["Drugi kolor starszy po naszym wejściu w stary - GF, pytanie o trzymanie w podstawowym wariancie"]},
                        {id: "20.2.2", name: ["Kolor starszy po naszym wejściu w młody - naturalne"]},
                    ]
                },
                {id: "20.3", name: ["2NT - (15)16-18, Bal" ], children:
                    [
                        {id: "20.3.1", name: ["Licytujemy jak po otwarciu 2NT" ]},
                    ]
                },
                {id: "20.4", name: ["Na czwartym ręku po dwóch pasach" ], children:
                    [
                        {id: "20.4.1", name: ["Przed partią - około zrównoważony"]},
                        {id: "20.4.2", name: ["Po partii - wywoławcza do kar"]},
                    ]
                },
            ]
        },
        {id: 10, name: ["Po słabym 1NT"," - ","dowolne w przedziale od 8 do 14"], children:
            [
                {id: "10.0", name: ["Wszystkie wejścia w sile konstruktywnej"]},
                {id: "10.1", name: ["x - 15+, skład około zrównoważony"]},
                {id: "10.2", name: ["2",<GiClubs />," - ","stare"]},
                {id: "10.3", name: ["2NT"," - ","oba młode"]},
                {id: "10.4", name: ["Inne - naturalne"]},
            ]
        },
        {id: 14, name: ["Na silnego trefla (15+ dowolny) - tzw. CRUSH"], children:
            [
                {id: "14.1", name: ["x - ","czarne lub czerwone, dwukolorówka 55"]},
                {id: "14.2", name: ["1",<GiDiamonds />," - ","młode lub stare, dwukolorówka 55"]},
                {id: "14.3", name: ["1",<GiHearts />,"- ","naturalne"]},
                {id: "14.4", name: ["1",<GiSpades />,"","naturalne"]},
                {id: "14.5", name: ["1NT","okrągłe lub szpiczaste"]},
            ]
        },
        {id: 15, name: ["Na 1",<GiDiamonds />," przygotowawcze"], children:
            [
                {id: "15.1", name: ["x - "," na kolory starsze"]},
                {id: "15.2", name: ["Inne wejścia - naturalne"]},
            ]
        },
        {id: 18, name: ["Po 2BA - młode"], children:
            [
                {id: "18.1", name: ["x - siłowa, z fitami w starych kolorach"]},
                {id: "18.2", name: ["3",<GiClubs />, "dwukolorówka na starych, lepsze kiery"]},
                {id: "18.3", name: ["3",<GiDiamonds />, "dwukolorówka na starych, lepsze piki"]},
                {id: "18.4", name: ["3",<GiHearts />, "naturalne"]},
                {id: "18.5", name: ["3",<GiSpades />, "naturalne"]},
            ]
        },
        {id: 17, name: ["Po 3BA - gambling"], children:
            [
                {id: "17.1", name: ["x - siłowa, z fitami w starych kolorach"]},
                {id: "17.2", name: ["4",<GiClubs />, "dwukolorówka na starych, lepsze kiery"]},
                {id: "17.3", name: ["4",<GiDiamonds />, "dwukolorówka na starych, lepsze piki"]},
                {id: "17.4", name: ["4",<GiHearts />, "naturalne"]},
                {id: "17.5", name: ["4",<GiSpades />, "naturalne"]},
            ]
        },
        {id: 11, name: ["Po kontrze wywoławczej"], children:
            [
                {id: "11.1", name: ["Na 1",<GiClubs />], children:
                    [
                        {id: "11.1.1", name: ["1",<GiDiamonds />,"Dowolne 0-6"]},
                        {id: "11.1.2", name: ["1",<GiHearts />,"4 kiery, F1 przed pasem"]},
                        {id: "11.1.3", name: ["1",<GiSpades />,"4 piki, F1 przed pasem"]},
                        {id: "11.1.4", name: ["1NT","Bez starszych czwórek, okołozrównoważona, 7-10(11)"]},
                        {id: "11.1.5", name: ["2",<GiClubs/>,"niezrównoważona z 5+ trefli, 7-9(10)"]},
                        {id: "11.1.6", name: ["2",<GiDiamonds/>,"niezrównoważona z 5+ karami, 7-9(10)"]},
                        {id: "11.1.7", name: ["2",<GiHearts/>,"bilansowe z 5+ kierami"]},
                        {id: "11.1.8", name: ["2",<GiSpades/>,"bilansowe z 5+ pikami"]},
                        {id: "11.1.9", name: ["2NT","Bilansowe, bez starszych czwórek"]},
                    ]
                },
                {id: "11.2", name: ["Na 1",<GiDiamonds />], children:
                    [
                        {id: "11.2.1", name: ["Generalnie - naturalne, bilansowe"]},
                        {id: "11.2.2", name: ["2",<GiDiamonds />], children:
                            [
                            {id: "11.2.2.1", name: ["Przed pasem - co najmniej jedna starsza czwórka inwit+ (F1) lub GF na młodym"]},
                            {id: "11.2.2.2", name: ["Po pasie - co najmniej jedna starsza czwórka w sile inwitu (F1) lub inwit na obu młodych"]}
                            ]
                        },
                        {id: "11.2.3", name: ["3",<GiDiamonds />,"Pytanie o trzymanie, GF, bez aspiracji do szlemika"]},
                    ]
                },
                {id: "11.3", name: ["Na stary"], children:
                    [
                        {id: "11.3.1", name: ["Generalnie - naturalne, bilansowe"]},
                        {id: "11.3.2", name: ["2 w kontrowany stary"], children:
                            [
                            {id: "11.3.2.1", name: ["Przed pasem - druga starsza czwórka inwit+ (F1) lub GF"]},
                            {id: "11.3.2.2", name: ["Po pasie - druga starsza czwórka w sile inwitu (F1) lub inwit na obu młodych"]}
                            ]
                        },
                        {id: "11.3.3", name: ["3",<GiDiamonds />,"Pytanie o trzymanie, GF, bez aspiracji do szlemika"]},
                    ]
                },
                {id: "11.4", name: ["Jeżeli następuje licytacja drugiego obrońcy"], children:
                    [
                        {id: "11.4.1", name: ["Generalnie - naturalne, bilansowe, kolor starszy może być z czwórki"]},
                        {id: "11.4.2", name: ["Kontra na kolor wskazany tylko z czwórki - na wprost"]},
                        {id: "11.4.3", name: ["Kontra na kolor wskazany z piątki - wywoławcza, pozostałe kolory"]}, 
                        {id: "11.4.4", name: ["Kontra na podniesienie starego koloru - dokładnie czwórka w drugim starym (?)"]},
                    ]
                },

            ],

        },
        {id: 12, name: ["Po naszym wejściu BA"], children:
            [
                {id: "12.1", name: ["Jeżeli zostało skontrowane"], children:
                    [
                        {id: "12.1.1", name: ["pas - nic ciekawego"]},
                        {id: "12.1.2", name: ["xx - trefle albo dwukolorówka bez trefli"]},
                        {id: "12.1.3", name: ["2c - dwukolorówka z treflami"]},
                        {id: "12.1.4", name: ["Inne - naturalne"]},
                    ]
                },
                {id: "12.2", name: ["Po otwarciu w młody, jeżeli padł pas - w pełni system on"]},
                {id: "12.3", name: ["Po otwarciu w młody, jeżeli padł pas - transfery na okrąło"], children:
                    [
                        {id: "12.3.1", name: ["2",<GiClubs />, " - ","Transfer na kara"]},
                        {id: "12.3.2", name: ["Transfer na kolor przeciwnika - odpowiednik Staymana"]},
                        {id: "12.3.3", name: ["Inne - system ON"]},
                    ]
                },
            ]
        },
        {id: 19, name: ["Po wejściu 3BA bez przeskoku"], children:
            [
                {id: "19.1", name: ["Jeżeli wejście nastąpiło po bloku na kolorze młodszym"], children:
                    [
                        {id: "19.1.1", name: ["4",<GiClubs />," - ","oba stare"]},
                        {id: "19.1.2", name: ["4",<GiDiamonds />," - ","transfer na kiery"]},
                        {id: "19.1.3", name: ["4",<GiHearts />," - ","transfer na piki"]},
                        {id: "19.1.4", name: ["4",<GiSpades />," - ","inwit z długością w drugim młodym"]},
                    ]
                },
                {id: "19.2", name: ["Jeżeli wejście nastąpiło po bloku na kolorze młodszym"], children:
                    [
                        {id: "19.2.1", name: ["4",<GiClubs className="icon-with-space"/>," - ","inwit do szlemika z czwórką w drugim starym"]},
                        {id: "19.2.2", name: ["4",<GiDiamonds className="icon-with-space"/>," - ","transfer na kiery"]},
                        {id: "19.2.3", name: ["4",<GiHearts className="icon-with-space"/>," - ","transfer na piki"]},
                        {id: "19.2.4", name: ["4",<GiSpades className="icon-with-space"/>," - ","inwit z długością w drugim młodym"]},
                    ]
                },
            ]
        },
        {id: 13, name: ["Inne konwencje i sekwencje w licytacji dwustronnej"], children:
            [
                {id: "13.1", name: ["2",<GiClubs className="icon-with-space"/>,"Drury - po otwarciu trzecioręcznym lub wejściu kolorem starszym i pasie przeciwnika. Obiecuje siłę inwitu z fitem"], children:
                    [
                        {id: "13.1.1", name: ["2",<GiDiamonds className="icon-with-space"/>," - ","siła w okolicy otwarcia"]},
                        {id: "13.1.2", name: ["2 w kolor wejścia - ","słaba karta"]},
                        {id: "13.1.3", name: ["Inne poniżej 3 w kolor - ","warunkowe przyjęcie"]},

                    ]
                },
                {id: "13.2", name: ["2NT Lebensohl - wskazanie bardzo słabej karty na nieznanym kolorze, w następujących sekwencjach"], children:
                    [
                        {id: "13.2.1", name: ["1NT - (2Y) - 2NT"]},
                        {id: "13.2.2", name: ["(2Y) - x - (pas) - 2NT"]},
                        {id: "13.2.3", name: ["(??) 1",<GiClubs className="icon-with-space"/>," - (2Y) - pas - (pas) - x- (pas) - 2NT"]},
                    ]
                },
                {id: "13.3", name: ["Interwencja po otwarciu 2",<GiClubs className="icon-with-space"/>," i pytaniu 2", <GiDiamonds />], children:
                    [
                        {id: "13.3.0", name: ["pas - ","może być trap lub kiepska karta"]},
                        {id: "13.3.1", name: ["x - ","wywoławcza z drugim starym"], children: 
                            [
                                {id: "13.3.1.1", name: ["3",<GiClubs className="icon-with-space"/>," - ","do pasa"]},
                                {id: "13.3.1.2", name: ["3 w kolor przeciwnika - cuebid, ustala drugi stary"]},
                                {id: "13.3.1.3", name: ["4",<GiClubs className="icon-with-space"/>," - ", "ustalenie szlemikowe trefli"]},    
                            ]
                        },
                        {id: "13.3.2", name: ["xx - ","lepsza karta, raczej na treflach. Ewentualne późniejsze kontry są karne"]},
                    ]
                },
                {id: "13.4", name: ["Licytacja po interwencji, która nastąpiła po otwarciu i inwicie do koloru starszego"], children:
                    [
                        {id: "13.4.0", name: ["Poniższe obowiązują do wysokości 3 w nasz kolor. Jeżeli przeciwnicy zalicytowali wyżej pasy są NF, licytacja wskazuje pewne nadwyżki, kontry karne"]},
                        {id: "13.4.1", name: ["pas - ","forsuje, waham się nad przyjęciem"], children:
                            [
                                {id: "13.4.1.1", name: ["x - ","propozycyjna, wybieraj pomiędzy ukarnieniem a 3 w stary"]},
                            ]
                        },
                        {id: "13.4.2", name: ["x - ","karna"]},
                        {id: "13.4.3", name: ["3  kolor - najsłabsza licytacja"]},
                    ]
                },
                {id: "13.5", name: ["Jeżeli dwóch przeciwników licytowało a my daliśmy inwit"], children:
                    [
                        {id: "13.5.0", name: ["Poniższe obowiązują do wysokości 3 w nasz kolor. Jeżeli przeciwnicy zalicytowali wyżej pasy są NF, licytacja wskazuje pewne nadwyżki, kontry karne"]},
                        {id: "13.5.1", name: ["To my otwieraliśmy"], children:
                            [
                                {id: "13.5.1.1", name: ["pas - ","forsuje, waham się nad przyjęciem"]},
                                {id: "13.5.1.2", name: ["x - ","nie mam na przyjęcie, ale mam trochę defensywy, zrób z tym coś mądrego"]},
                                {id: "13.5.1.3", name: ["3  kolor - najsłabsza licytacja"]},
                            ]
                        },
                        {id: "13.5.2", name: ["To oni otwierali, a my wchodziliśmy"], children:
                            [
                                {id: "13.5.2.1", name: ["pas - ","uważaj, mam kompletne minumum"]},
                                {id: "13.5.2.2", name: ["x - ","jestem bliski przyjęcia inwitu, w pełni wywoławcza!"]},
                                {id: "13.5.2.3", name: ["3  kolor - normalne wejście, nie przyjmuję inwitu"]},
                            ]
                        },
                    ],
                },
                {id: "13.6", name: ["4BA w dynamicznej licytacji dwustonnej"], children:
                    [
                        {id: "13.6.1", name: ["Jeżeli mieliśmy forsująco uzgodniony kolor - karta inwitująca do szlemika"]},
                        {id: "13.6.2", name: ["Jeżeli tylko jedno z nas licytowało - 6 we wcześniej licytowanym kolorze, czwórka bokiem"]}
                    ]
                },
                {id: "13.7", name: ["2BA wcześniej wchodzącego"], children:
                    [
                        {id: "13.7.1", name: ["Jeżeli był jeden kolor wskazany przez preciwników - 6 w kolorze wejścia i czwórka nieznana"]},
                        {id: "13.7.2", name: ["Przykład: (1",<GiSpades />,") - 2", <GiHearts />," - (2",<GiSpades />,") - pas - (pas) - 2NT"]},
                        {id: "13.7.3", name: ["Jeżeli dwa kolor były wskazane 64 jest wskazane jednoznacznie"]},
                    ]

                }
            ]
        },

    ]
};

const dataA = flattenTree(systemDwustronnaKuba);

function DwustronnaKuba() {
    const [expandedIdsA, setExpandedIdsA]  = useState();
    const [data, setData] = useState(dataA)

    const onKeyDown = (e) => {
        if (e.key === 'Enter'){
            getAndSetIds();
        }
    }

    const getAndSetIds = () => {
        setExpandedIdsA(
            document
                .querySelector('#txtIdsToExpand')
                .value.split(",")
                .filter(val => !!val.trim())
                .map((x)=>{
                    if (isNaN(parseInt(x.trim()))){
                        return x;
                    }
                    return parseInt(x.trim());
                })
        );
    };

    const expandAll = () => {
        const allNodeIds = flattenTree(systemDwustronnaKuba).map(node => node.id);
        setExpandedIdsA(allNodeIds);
    }

    return (
        <div>
            <div>
                <Button onClick={()=>expandAll()}>Expand all</Button>
                <Button onClick={() => setExpandedIdsA([])}> Collapse all</Button>
            </div>
            <div className="checkbox">
                <TreeView
                    data = {dataA}
                    aria-label = "Controlled expanded node tree"
                    expandedIds={expandedIdsA}
                    defaultExpandedIds={[]}
                    nodeRenderer={({
                        element,
                        isBranch,
                        isExpanded,
                        isDisabled,
                        getNodeProps,
                        level,
                        handleExpand,
                    })=>{
                        return (
                            <div
                                {...getNodeProps({onClick: handleExpand})}
                                style = {{
                                    marginLeft: 40*(level-1),
                                    opacity: isDisabled ? 0.5 : 1,
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center'
                                }}
                            >
                                {isBranch && <ArrowIcon isOpen = {isExpanded}/>}
                                <span style={{display: 'flex', alignItems: 'center'}} >
                                    {element.name}
                                    </span>
                            </div>
                        );
                    }}
                    />
            </div>
        </div>
    );

}

const ArrowIcon = ({isOpen, className}) => {
    const baseClass = "arrow";
    const classes = cx(
        baseClass,
        {[`${baseClass}--closed`]: !isOpen},
        {[`${baseClass}--open`]: isOpen},
        className
    );
    return <IoMdArrowDropright className={classes} />;
}

export default DwustronnaKuba